import { TRootState } from "../store/create-store";
import { TColumnName } from "../types";
import { selectRootState } from "../selectors";

export const isColumnCategorical = (state: TRootState, column: TColumnName) => {
  const { categoricalColumns, categoricalPredictionColumns } =
    selectRootState(state);

  return column
    ? categoricalColumns.includes(column) ||
        categoricalPredictionColumns.includes(column)
    : false;
};

export const selectConScores = (state: TRootState) =>
  selectRootState(state).conScores;
